import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import domain from '../../constants/config.js';

const apiUrl = domain.API_BASE_URL+'v1/payment-details';

export const getpaymentDetails = createAsyncThunk(
  'payment/getpaymentDetails',
  async (data) => {
    try {
        console.log("getpaymentDetails",data);
      const response = await axios.post(apiUrl,data);
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
);

const paymentsListSlice = createSlice({
  name: 'paymentsList',
  initialState: {
    data:[],
    response: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getpaymentDetails.pending, (state) => {
        state.loading = true;
        console.log("getpaymentDetails",state.loading);
      })
      .addCase(getpaymentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;

      })
      .addCase(getpaymentDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default paymentsListSlice.reducer;